import React from 'react';
import PropTypes from 'prop-types';
import { Translate } from 'react-localize-redux';
import Icon, { IconSizes } from '../../components/foundations/Icon';
import MetricTiles from './MetricTiles';
import { TRANSLATION_KEY, VERDICT_TYPES } from '../constants';
import { verdictShape } from '../propShapes';
import { formatNextRunLabel } from '../utils';
import css from './VerdictBody.css';

const CARD_KEY = `${TRANSLATION_KEY}.CARD`;

const VerdictBody = ({ isPromptUnclear, verdict = null, nextRunAt = null, checkInProgress = false }) => {
    if (isPromptUnclear) {
        return (
            <div>
                <div className={css.newMessageChip}>
                    <Icon name="message-circle" size={IconSizes.X_SMALL} interactive={false} />
                    <Translate id={`${CARD_KEY}.NEW_MESSAGE`} />
                </div>
                <div className={css.mutedBody}>{verdict.headline}</div>
                <div className={css.openLink}>
                    <Translate id={`${CARD_KEY}.OPEN_TO_REPLY`} />
                </div>
            </div>
        );
    }
    if (!verdict && checkInProgress) {
        return (
            <div className={css.mutedBody}>
                <Translate id={`${CARD_KEY}.FIRST_CHECK_IN_PROGRESS`} />
            </div>
        );
    }
    if (!verdict) {
        const firstRunLabel = formatNextRunLabel(nextRunAt);
        return (
            <div className={css.mutedBody}>
                {firstRunLabel ? (
                    <Translate id={`${CARD_KEY}.FIRST_RUN`} data={{ firstRunLabel }} />
                ) : (
                    <Translate id={`${CARD_KEY}.NO_RUNS_YET`} />
                )}
            </div>
        );
    }
    const bodyByType = {
        [VERDICT_TYPES.ERROR]: <Translate id={`${CARD_KEY}.FAILED_BODY`} />,
        [VERDICT_TYPES.NO_VERDICT]: <Translate id={`${CARD_KEY}.NO_VERDICT_BODY`} />,
    };
    return (
        <div>
            <div className={css.body}>{bodyByType[verdict.type] ?? verdict.headline}</div>
            {verdict.type === VERDICT_TYPES.REPORT && verdict.metrics?.length > 0 && (
                <MetricTiles metrics={verdict.metrics} />
            )}
            <div className={css.openLink}>
                <Translate id={`${CARD_KEY}.OPEN_THREAD`} />
            </div>
        </div>
    );
};

VerdictBody.propTypes = {
    isPromptUnclear: PropTypes.bool.isRequired,
    verdict: verdictShape,
    nextRunAt: PropTypes.string,
    checkInProgress: PropTypes.bool,
};

export default VerdictBody;
